'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsyncComponent = function (_Component) {
  (0, _inherits3.default)(AsyncComponent, _Component);

  function AsyncComponent(props) {
    (0, _classCallCheck3.default)(this, AsyncComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AsyncComponent.__proto__ || (0, _getPrototypeOf2.default)(AsyncComponent)).call(this, props));

    _this.state = {
      component: null
    };
    return _this;
  }

  (0, _createClass3.default)(AsyncComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.loader(function (component) {
        _this2.setState({
          component: component.default
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.component) {
        return _react2.default.createElement(this.state.component, this.props);
      }

      return null;
    }
  }]);
  return AsyncComponent;
}(_react.Component);

exports.default = AsyncComponent;


AsyncComponent.propTypes = {
  loader: _propTypes2.default.func.isRequired,
  loadMask: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/async/AsyncComponent.js
// module id = 741
// module chunks = 10